module.exports = __webpack_public_path__ + "static/img/banner3.4b89c0f8.png";